import useJwt from '@core/auth/jwt/useJwt'
import axios from '@axios'

const { jwt } = useJwt(axios, {
  loginEndpoint: '/auth/member/login',
  logoutEndpoint: '/auth/member/logout'
})
export default jwt
